import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Spinner } from 'src/app/core/services/spinner.service';
import { CustomValidator } from 'src/app/shared/directive/custom-validator';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { PATH_ROUTING } from '../../../../../../shared/enums/routing-enums';
import { SrmService } from '../../../../../../shared/service/srm.service';

@Component({
  selector: 'app-create-edit-section',
  templateUrl: './create-edit-section.component.html',
  styleUrls: ['./create-edit-section.component.scss']
})
export class CreateEditSectionComponent implements OnInit {

  public isEdit = false;
  public selectLayout = 1;
  public title = '';
  public sectionForm: FormGroup;
  public sectionId: any;
  public apps: any[];
  constructor(
    private router: Router,
    private spinner: Spinner,
    private srmService: SrmService,
    private toastr: ToastrService,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.params.subscribe(res => {
      if (res.id) {
        this.isEdit = true;
        this.sectionId = res.id;
        this.getSectionById(this.sectionId);
      }
    });
  }

  ngOnInit() {
    this.initForm();
  }

  submit() {
    if (!this.sectionForm.valid) {
      this.markFormGroupTouched(this.sectionForm);
      return;
    }
    if (this.title !== '') {
      if (!this.isEdit) {
        this.spinner.show();
        this.srmService.addSections(this.sectionForm.getRawValue()).subscribe((res: any) => {
          this.spinner.hide();
          if (res.status === 200) {
            this.toastr.success(MESSAGE_TOAST.ADD_SECTION_SUCCESS);
            this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, PATH_ROUTING.PATH_SECTION]);
          }
        });
      } else {
        this.updateSections(this.sectionForm.getRawValue());
      }
    }
  }

  public initForm() {
    this.sectionForm = new FormGroup({
      id: new FormControl(this.sectionId || ''),
      title: new FormControl(this.title || '', [CustomValidator.required, CustomValidator.maxLength(50)]),
      layout: new FormControl(this.selectLayout || 1)
    });
  }

  private markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  public getSectionById(id) {
    this.spinner.show();
    this.srmService.getSectionById(id).subscribe(res => {
      this.spinner.hide();
      if (res.data) {
        this.title = res.data.title;
        this.selectLayout = res.data.layout;
        this.initForm();
      }
    }, (err) => {
      this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, PATH_ROUTING.PATH_SECTION]);
    });
  }

  public updateSections(requesModel) {
    this.spinner.show();
    this.srmService.updateSections(requesModel).subscribe((res: any) => {
      this.spinner.hide();
      if (res.status === 200) {
        this.toastr.success(MESSAGE_TOAST.UPDATE_SECTION_SUCCESS);
        this.router.navigate([PATH_ROUTING.PATH_SRM, PATH_ROUTING.PATH_ADMIN, PATH_ROUTING.PATH_SECTION]);
      }
    });
  }
}
